import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EMarketTrendsStatus } from 'shared/types/marketTrends';

const marketTrendsStatusSlice = createSlice({
  initialState: EMarketTrendsStatus.Initial,
  name: 'marketTrendsStatus',
  reducers: {
    setMarketTrendsStatus: (_, action: PayloadAction<EMarketTrendsStatus>) => action.payload,
  },
});

export const {
  reducer: marketTrendsStatusReducer,
  actions: { setMarketTrendsStatus },
} = marketTrendsStatusSlice;
